const styles = () => ({
  root: {},
  rootReactNativeWebView: {
    // backgroundColor: theme.palette.common.backgroundDark,
  },
});

export default styles;
